export const messages = {
  en: {
    floorShare: {
      title: 'Floor Share',
      id: 'ID',
      floor: 'Floor',
      meterType: 'Meter Type',
      meterNum: 'Meter Number',
      meterPosition: 'Meter Position',
      shareType: 'Share Type',
      formula: 'Formula',
      feeItem: 'Fee Item',
      feePrice: 'Fee Price',
      degree: 'Degree',
      readingTime: 'Reading Time',
      createTime: 'Create Time',
      addTitle: 'Add Floor Share',
      editTitle: 'Edit Floor Share',
      deleteConfirm: 'Confirm Operation',
      deleteMessage: 'Are you sure to delete this floor share?',
      fetchError: 'Failed to fetch floor share data',
      fetchFloorError: 'Failed to fetch floor data',
      fetchFeeConfigError: 'Failed to fetch fee config data',
      addSuccess: 'Floor share added successfully',
      addFailed: 'Failed to add floor share',
      editSuccess: 'Floor share updated successfully',
      editFailed: 'Failed to update floor share',
      deleteSuccess: 'Floor share deleted successfully',
      deleteFailed: 'Failed to delete floor share',
      meterTypeRequired: 'Please select meter type',
      feeItemRequired: 'Please select fee item',
      feePriceRequired: 'Please enter fee price',
      feePriceNumber: 'Fee price must be a number',
      shareTypeRequired: 'Please select share type',
      formulaRequired: 'Please enter formula',
      idRequired: 'ID is required',
      meterNumPlaceholder: 'Optional, please enter meter number',
      meterNumTip: 'Enter 1 if no meter number',
      meterPositionPlaceholder: 'Optional, please enter meter position',
      electricMeter: 'Electric Meter',
      waterMeter: 'Water Meter',
      publicDeductWaterMeter: 'Public Deduction Water Meter',
      publicDeductElectricMeter: 'Public Deduction Electric Meter',
      officeElectricFee: 'Office Electricity Fee',
      collectionPaymentMeter: 'Collection Payment Meter',
      allOwnerShareMeter: 'All Owner Share Meter',
      byArea: 'By Area',
      byHouse: 'By House',
      byFormula: 'By Formula',
      unit: 'Unit',
      meterRatio: 'Meter Ratio',
      meterRatioPlaceholder: 'Optional, please enter meter ratio (default 1)',
      isDeduction: 'Deduct Type',
      isDeductionAdd: 'Add',
      isDeductionDeduct: 'Deduct',
      selectFloorOrUnit: 'Please select a building or unit first'
    }
  },
  zh: {
    floorShare: {
      title: '楼栋公摊',
      id: '编号',
      floor: '楼栋',
      meterType: '表类型',
      meterNum: '表编号',
      meterPosition: '水电表位置',
      shareType: '公摊方式',
      formula: '公式',
      feeItem: '费用项',
      feePrice: '费用单价',
      degree: '度数',
      readingTime: '抄表时间',
      createTime: '创建时间',
      addTitle: '添加楼栋公摊',
      editTitle: '修改楼栋公摊',
      deleteConfirm: '请确认您的操作',
      deleteMessage: '确定删除楼栋公摊吗？',
      fetchError: '获取楼栋公摊数据失败',
      fetchFloorError: '获取楼栋数据失败',
      fetchFeeConfigError: '获取费用项数据失败',
      addSuccess: '楼栋公摊添加成功',
      addFailed: '楼栋公摊添加失败',
      editSuccess: '楼栋公摊修改成功',
      editFailed: '楼栋公摊修改失败',
      deleteSuccess: '楼栋公摊删除成功',
      deleteFailed: '楼栋公摊删除失败',
      meterTypeRequired: '请选择表类型',
      feeItemRequired: '请选择费用项',
      feePriceRequired: '请输入费用单价',
      feePriceNumber: '费用单价必须为数字',
      shareTypeRequired: '请选择公摊方式',
      formulaRequired: '请输入公式',
      idRequired: '编号不能为空',
      meterNumPlaceholder: '选填，请填写表编号',
      meterNumTip: '没有表号请填写1',
      meterPositionPlaceholder: '选填，请填写水电表位置',
      electricMeter: '电表',
      waterMeter: '水表',
      publicDeductWaterMeter: '公摊扣减水表',
      publicDeductElectricMeter: '公摊扣减电表',
      officeElectricFee: '办公电费表',
      collectionPaymentMeter: '代收代缴电表',
      allOwnerShareMeter: '全体业主共同分摊电表',
      byArea: '按面积',
      byHouse: '按户',
      byFormula: '按公式',
      unit: '单元',
      meterRatio: '倍率',
      meterRatioPlaceholder: '选填，请填写倍率（默认1）',
      isDeduction: '增减类型',
      isDeductionAdd: '增加',
      isDeductionDeduct: '扣减',
      selectFloorOrUnit: '请先选择楼栋或单元'
    }
  }
}